module.exports = __webpack_public_path__ + "assets/b3.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b3.png
// module id = 616
// module chunks = 0